import { ReactComponent as SteamApiKeyIcon } from './steamApiKey.svg';
import { ReactComponent as SteamTradeIcon } from './steamTrade.svg';
import { ReactComponent as WarningIcon } from './warning.svg';

export const SvgIcons = {
  SteamApiKeyIcon,
  SteamTradeIcon,
  WarningIcon,
};
